import { Autocomplete, AutocompleteProps, TextField } from '@mui/material';
import { Control, Controller, Path, UseControllerProps } from 'react-hook-form';

interface PropTypes<T>
  extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput'> {
  name: Path<T>;
  control: Control<any>;
  rules?: UseControllerProps['rules'];
  label?: string;
  disabled?: boolean;
  options: any[];
}

export const ControlledAutocomplete = <T extends unknown>({
  name,
  control,
  rules,
  options,
  label,
  disabled,
  ...props
}: PropTypes<T>) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value, ...field }, fieldState }) => (
      <Autocomplete
        {...field}
        value={value ?? []}
        options={options}
        disabled={disabled}
        renderInput={params => (
          <TextField
            {...params}
            error={!disabled && !!fieldState.error}
            helperText={!disabled && fieldState.error?.message}
            label={label}
          />
        )}
        onChange={(_, data) => onChange(data)}
        disablePortal
        {...props}
      />
    )}
  />
);
